import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { PageSizeProvider } from '@xt/data-access';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const defaultHandsetPageSize = 5;
const defaultDesktopPageSize = 10;

@Injectable({ providedIn: 'root' })
export class DefaultPageSizeService implements PageSizeProvider {
  defaultPageSize$: Observable<number> = this.breakpointObserver
    .observe([Breakpoints.Handset])
    .pipe(
      map((bp) =>
        bp.matches ? defaultHandsetPageSize : defaultDesktopPageSize,
      ),
    );

  constructor(private readonly breakpointObserver: BreakpointObserver) {}
}
